import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { useRef } from 'react';
import { PERCEPTION_VOUCHER_BANNER } from '../../pricingPerception';
import { FAQs } from '../../Components/FAQs';
import { SiteGateHeader } from '../../Components/Headers';
import { MoreTools } from '../../Components/MoreTools';
import { PreSuggestionsOptimized } from '../../Components/PreSuggestionsOptimized';
import { TldPromotionBoxes } from '../../Components/TldPromotionBoxes';
import { VoucherBanner } from '../../Components/VoucherBanner';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useGateScrollBi } from '../../hooks/useGateScrollBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { prefetchRecommendations } from '../../hooks/useRecommendations';
import { useViewTransition } from '../../hooks/useViewTransition';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ViewMode } from '../../types';
import transition from '../viewTransitions.css';
import { HeroSearchBar } from './HeroSearchBar';
import s from './siteLevelGateHomeOptimized.scss';
import { useDeclaredExperiments } from '../../hooks/declaredExperiments';
import { useGatePageBackground } from '../../hooks/useGatePageBackground';
export const SiteLevelGateHomeOptimizedContent = function (_temp) {
  let {
    viewMode = ViewMode.GATE,
    perception = false
  } = _temp === void 0 ? {} : _temp;
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  const {
    navigateTo
  } = useViewTransition();
  const experimentIds = useDeclaredExperiments();
  const {
    getUrlState
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  const pageBackground = useGatePageBackground();
  const pageRef = useRef(null);
  const searchbarRef = useRef(null);
  const tldGridRef = useRef(null);
  const faqRef = useRef(null);
  useDomainSearchGateBi({
    viewMode,
    pageType: 'landing'
  });
  useGateScrollBi({
    containerRef: pageRef,
    sections: [{
      section: 'searchbar',
      ref: searchbarRef
    }, {
      section: 'tld_grid',
      ref: tldGridRef
    }, {
      section: 'faq',
      ref: faqRef
    }]
  });
  useQuerySubmit({});
  return /*#__PURE__*/React.createElement(Box, {
    ref: pageRef,
    direction: "vertical",
    align: "center",
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: pageBackground,
    scrollBehavior: "smooth",
    boxSizing: "border-box",
    padding: "24px 40px"
  }, /*#__PURE__*/React.createElement("section", {
    className: s.firstFold,
    ref: searchbarRef
  }, /*#__PURE__*/React.createElement("div", {
    className: s.voucherBanner
  }, /*#__PURE__*/React.createElement(VoucherBanner, {
    optimizedVoucherCopy: true,
    configOverrides: perception ? PERCEPTION_VOUCHER_BANNER : undefined
  })), /*#__PURE__*/React.createElement(Box, {
    className: `${s.hero} ${transition.header}`,
    direction: "vertical",
    align: "center",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "8px",
    backgroundColor: "#E6E2FF"
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.heroSearch,
    direction: "vertical",
    align: "center",
    gap: "20px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(SiteGateHeader, {
    className: s.heroHeader,
    gap: "20px",
    genericTitleForDefaultSiteName: true
  }), /*#__PURE__*/React.createElement("div", {
    className: `${s.searchBarWrapper} ${transition.searchBar}`
  }, /*#__PURE__*/React.createElement(HeroSearchBar, {
    onSubmit: filters => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'search',
        value: filters.query || undefined
      });
      prefetchRecommendations({
        experimentIds
      });
      setTimeout(() => {
        const searchParams = getUrlState(filters);
        navigateTo(`/results?${searchParams}`);
      }, 500);
    }
  }))), /*#__PURE__*/React.createElement(PreSuggestionsOptimized, {
    perception: perception
  }))), /*#__PURE__*/React.createElement("main", {
    className: `${s.mainContent} ${transition.content}`,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    className: s.content
  }, /*#__PURE__*/React.createElement("div", {
    ref: tldGridRef
  }, /*#__PURE__*/React.createElement(TldPromotionBoxes, null)), /*#__PURE__*/React.createElement(MoreTools, null), /*#__PURE__*/React.createElement("div", {
    ref: faqRef
  }, /*#__PURE__*/React.createElement(FAQs, {
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  })))));
};
//# sourceMappingURL=SiteLevelGateHomeOptimizedContent.js.map